module.exports = function() {
  return new Worker(__webpack_public_path__ + "assets/auth.worker.5184e5db09ad3ae7c06d.js");
};